import { apiClient } from './apiClients';
import { Endpoints } from '../network';

let userProfilePromise: Promise<any | null> | null = null;

export const getUserProfile = async () => {
  if (!userProfilePromise) {
    userProfilePromise = apiClient
      .get(Endpoints.getUser)
      .then((response) => response?.data)
      .finally(() => {
        userProfilePromise = null;
      });
  }

  return userProfilePromise;
};

export const getUserProfileDirect = async () => {
  const response = await apiClient.get(Endpoints.getUser);

  return response?.data;
};

export const updateProfile = async (data: {
  name?: string;
  email?: string;
  phone?: string;
  password?: string;
}) => {
  const response = await apiClient.post(`${Endpoints.updateProfile}`, data);

  return response?.data;
};

export const uploadProfileImage = async (image: File) => {
  const formData = new FormData();
  formData.append('image', image);

  try {
    const response = await apiClient.post(
      Endpoints.updateProfileImage,
      formData,
    );
    return response?.data;
  } catch (error) {
    console.error('Error uploading profile image:', error);
    throw error;
  }
};

export const googleOneTapLogin = async (data: {
  credential: string;
  ref_code?: string;
}) => {
  const response = await apiClient.post(Endpoints.googleOneTap, data);
  return response?.data;
};
